import moment from 'moment-timezone';

export const adaptSLATimingResponse = (response) => {
  const utcTimeFromResponse = response?.scheduleInfo?.backupStartTime || {};
  const utcTime = moment?.utc(utcTimeFromResponse);
  utcTime.tz('Asia/Kolkata');
  utcTime.format('HH:mm')?.toString();
  return `${utcTime.format('HH:mm')?.toString()}` || '-';
};
